import { render, staticRenderFns } from "./AsetQrcodes.vue?vue&type=template&id=2128b004"
import script from "./AsetQrcodes.vue?vue&type=script&lang=js"
export * from "./AsetQrcodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports